import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#EBE9F1'
const currentYear = new Date().getFullYear();
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#EBE9F1',
        backgroundColor: '#F8F8F8',
        color: '#888888',
        alignItems: 'center',
        height: 24,
        textAlign: 'left',
        fontStyle: 'bold',
        paddingLeft: 15,
        marginTop: 5,
    },
    year: {
        width: '20%',
        borderRightColor: borderColor,
    },
});

const PageFourConstructionValueTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.year}>{currentYear}</Text>
        <Text style={styles.year}>{currentYear - 1}</Text>
        <Text style={styles.year}>{currentYear - 2}</Text>
        <Text style={styles.year}>{currentYear - 3}</Text>
        <Text style={styles.year}>{currentYear - 4}</Text>
    </View>
);

export default PageFourConstructionValueTableHeader;
